"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Forms = void 0;
var React = require("react");
var Forms = /** @class */ (function (_super) {
    __extends(Forms, _super);
    function Forms() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Forms.prototype.render = function () {
        return (React.createElement("form", { id: this.props.data.form.id, method: this.props.data.form.method, action: this.props.data.form.action, acceptCharset: this.props.data.form.accept_charset
                ? this.props.data.form.accept_charset
                : "", encType: this.props.data.form.enctype ? this.props.data.form.enctype : "", className: (this.props.data.form.class ? this.props.data.form.class : "") + " " + this.props.className },
            this.props.data.fields.length
                ? this.props.data.fields.map(function (field, i) {
                    var value = false;
                    if (field.name === "checkout_url") {
                        var element = document.getElementsByName("checkout_url");
                        //@ts-ignore
                        value = element ? element[0].value : false;
                    }
                    return (React.createElement("input", { key: i, name: field.name, type: field.type, value: value ? value : field.value }));
                })
                : null,
            this.props.children));
    };
    return Forms;
}(React.Component));
exports.Forms = Forms;
//# sourceMappingURL=forms.js.map